import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useUser } from './UserContext';
import WelcomeCard from './WelcomeCard';
import SectionCard from './SectionCard';

const FAQ = () => {
  const { user } = useUser();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      flex: 1,
      paddingTop: '50px',
      paddingBottom: '50px',
    }}>
      <div style={{position: 'absolute', left: '0px', top: '0px', width:'100%', opacity: '10%', pointerEvents: 'none' }}>
        <img src='/mascot.png' alt=''/>
      </div>

      {!user && (
        <WelcomeCard />
      )}

      <SectionCard
        headline="How do I save my votes?"
        text="Your vote is recorded when you click the thumbs up icon. Clicking it again will remove your vote. You can track how many votes you've recorded and how many you have left at the top of the contest page."
        index={0}
      />

      <SectionCard
        headline="What is special about your voting?"
        text="When voting is opened to your club members, the list of photos is uniquely randomized for each member, that is, they see the list of photos in a special order. This means that no two members will see the photos in the same order, so the bias that tends to occur on the first bunch of photos is eliminated. During the voting period, members also cannot see vote counts, photographer names or submitter names, only titles. Our system prevents bandwagon voting and photograph fatigue that can occur when there are a lot of photos to view."
        index={1}
      />

      <SectionCard
        headline='Is "free" really free?'
        text="Yes, our free tier is totally free: we don't even ask for your payment information. You can upgrade to a higher tier at any time. The Snapperish platform was built with savings in mind, allowing us to pass the low infrastructure costs on to your club."
        index={2}
      />

      <SectionCard
        headline="What else are you working on?"
        text="We have a couple of features we are considering: Gallery Imports so that you can build your photo gallery quickly without needing to verify each photo or enter the photo details. We are also looking at introducing an affiliate program where you can get a share of the subscription fee for referring clubs to Snapperish."
        index={3}
      />

      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-around',
          padding: 6,
          textAlign: { xs: 'center', sm: 'left' },
          marginBottom: '40px',
          width: '100%',
          maxWidth: '1200px',
        }}
      >
        <Box sx={{ flex: 1, textAlign: 'left', margin: { xs: '16px 0', sm: 0 } }}>
          <Typography variant="h5" gutterBottom>
            What would YOU like to see on Snapperish?
          </Typography>
          <Typography variant="body1">
            We'd love to hear from you! Head over to our{' '}
            <Link to="/contact" style={{ color: 'inherit' }}>contact page</Link>
            {' '}and let us know what features or improvements would make Snapperish better for your club.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default FAQ;
